var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPinkGallery = function SvgPinkGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 929,
    height: 458,
    viewBox: "0 0 929 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M651.227 4.1483C102.054 -31.8193 -215.015 213.862 170.351 393.594C555.718 573.326 715.789 318.969 741.899 276.203C768.009 233.437 1200.4 40.1159 651.227 4.1483Z",
    fill: "#C685E6",
    fillOpacity: 0.13
  })));
};
export default SvgPinkGallery;